module.exports = __webpack_public_path__ + "media/images/external_link-1785dcde6cd3d43a357f9dd2010da7f0.png";